import { css } from 'emotion';

import { colors, icons, navbar } from '../styles';

export const tab = css`
  background-color: ${colors.white};
  width: 440px;
  overflow-x: hidden;
`;

const controlsBorderHeight = 4;

export const tabControls = css`
  overflow: hidden;
  border-bottom: ${controlsBorderHeight}px solid ${colors.gray.light};
  background-color: ${colors.gray.lightest};
  display: flex;
  align-items: center;

  &:empty {
    border-bottom: none;
  }

  button[role="tabControlAction"] {
    min-width: auto;
    max-height: 40px;
    margin-left: 10px;
    padding: 0 10px;
    background-color: ${colors.gray.lightest};

    &:hover {
      background-color: ${colors.custom.lightGray50};
    }

    & span {
      color: ${colors.gray.dark};
    }

    svg {
      margin-right: 10px;
      width: ${icons.size.small};
      height: ${icons.size.small};

      & path {
        fill: currentColor;
      }
    }
  }
`;

export const tabContent = css`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px);
  overflow-y: auto;

  input[type="checkbox"] {
    position: absolute;
  }

  &:empty {
    display: none;
  }
`;

export const toggle = (disabled?: boolean) => css`
  outline: none;
  border: 0;
  display: flex;
  align-items: center;
  border-radius: 0;
  margin: 0 0 0 auto;
  padding: 8px;
  background-color: ${colors.gray.lightest};
  min-height: ${navbar.height - controlsBorderHeight}px;
  color: ${disabled ? colors.gray.default : colors.gray.dark};
  cursor: ${disabled ? 'not-allowed' : 'pointer'};

  ${
    !disabled &&
    `&:hover {
      background-color: ${colors.custom.lightGray50};
    }`
  };
`;

export const arrowIconStyle = (isOpen: boolean, disabled?: boolean) => css`
  transform: rotate(${!isOpen || disabled ? 0 : -180}deg);
  color: ${disabled ? colors.gray.light : colors.gray.dark};

  && {
    transition: transform 0.5s;
    font-size: ${icons.size.large};
  }
`;

export const backToTopButton = css`
  && {
    position: absolute;
    bottom: 23px;
    right: 23px;
  }
`;
